// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle-" + {"327":"5d9987050ee79dd198e4","362":"e8a540ac70b88f4fbb61","722":"14688cdfc5d5b6c3c0e8"}[chunkId] + ".min.js";
};